module.exports = __webpack_public_path__ + "img/authen_zuzhi.ba722467.png";